import { StudyDashboardWithTabs } from './components/StudyDashboard';
import Connector from './connector';
import { StudyDashboardProps } from './StudyDashboard.proptype';

export const StudyDashboard = (props: StudyDashboardProps) => (
  <Connector {...props} component={StudyDashboardWithTabs} />
);
